import { useI18N } from "@sundae/react-hooks";
import { TPool } from "../../types/Pool.types";
import { slotToUnix, unixToSlot } from "../../utils/slots.utils";

export const useMarketOpenForPool = (pool: TPool) => {
  const { currentLocale } = useI18N();
  const now = new Date().getTime();
  const nowSlot = unixToSlot(now / 1000);

  const marketOpenSlot: number = pool.marketOpen?.slot || 0;

  const marketOpenDate = new Date(slotToUnix(marketOpenSlot) * 1000);
  const formattedMarketOpenDate = new Intl.DateTimeFormat(currentLocale).format(marketOpenDate);

  return {
    formattedMarketOpenDate,
    isMarketOpen: nowSlot >= marketOpenSlot,
    marketOpenSlot,
  };
};
